import { ScanLine, ShieldCheck, Users, ReceiptText } from "lucide-react";
import { IMAGES, Reveal, Eyebrow } from "../lib/data";

const FEATURES = [
  { icon: ScanLine, title: "Tehnologie digitală 3D", desc: "Vedem totul clar înainte să începem. Fiecare tratament e planificat digital." },
  { icon: ShieldCheck, title: "Tratament 100% fără durere", desc: "Anestezie modernă și multă răbdare. Nu simți aproape nimic." },
  { icon: Users, title: "Aceeași echipă, din 2019", desc: "Te cunoaștem pe nume. La fiecare vizită găsești aceiași oameni." },
  { icon: ReceiptText, title: "Prețuri clare & plată în rate", desc: "Îți spunem de la început cât costă. Poți plăti și în rate." },
];

const WhyUs = () => (
  <section className="py-20 lg:py-28 bg-[#FBF7EF]" data-testid="why-us-section">
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div>
        <Reveal>
          <Eyebrow>De ce MEDAS</Eyebrow>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
            Îngrijire dentară premium, aproape de tine
          </h2>
        </Reveal>
        <div className="mt-10 space-y-7">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08} className="flex gap-4" data-testid={`why-feature-${i}`}>
              <span className="w-12 h-12 rounded-xl bg-white border border-[#EADFC6] flex items-center justify-center shrink-0 shadow-sm">
                <f.icon className="w-5 h-5 text-[#A6823B]" />
              </span>
              <div>
                <h3 className="font-display font-bold text-[#2A2521]">{f.title}</h3>
                <p className="text-sm text-[#6B5C43] mt-1 leading-relaxed">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.15} className="relative">
        <div className="grid grid-cols-2 gap-4">
          <div className="rounded-3xl overflow-hidden shadow-xl shadow-[#2A2521]/10 aspect-[3/4]">
            <img src="/hol/hol5.jpg" alt="Holul clinicii MEDAS Timișoara" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="rounded-3xl overflow-hidden shadow-xl shadow-[#2A2521]/10 aspect-[3/4] mt-10">
            <img src="/spatii/cabinet3.jpg" alt="Cabinet de tratament MEDAS — unit dentar modern" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
        </div>
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-[#2A2521] text-white rounded-2xl px-6 py-4 shadow-2xl flex items-center gap-4 whitespace-nowrap" data-testid="why-us-badge">
          <span className="font-display text-2xl font-extrabold text-[#DCC79A]">50.000+</span>
          <span className="text-sm text-white/80">pacienți îngrijiți<br />din 2019</span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhyUs;
